<template>
  <v-layout column>
    <v-sheet>
      <v-card>
        <v-card-title primary-title>
          <v-btn icon @click="$router.go(-1)">
            <v-icon>mdi-arrow-left-bold-outline</v-icon>
          </v-btn>
          <h2>{{ $t('SETTINGS_TITLE') }}</h2>
<v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug" absolute right ><v-icon>mdi-bug-outline</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
        <v-layout wrap>
      <v-flex sm12 md6>
<span v-if="debug">{{ availableFields }}</span>
        <v-list>
          <v-list-group
            v-for="(group, idx) in availableFields"
            :key="idx"
            v-model="groups[group.id]"
            :prepend-icon="group.icon"
            no-action
            :value="true"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ group.header }} <span v-if="selectedAvailableFields.filter(a => a.group === group.id).length" class="body-1">({{ $t('SETTINGS_CONTACTS_NUM_SELECTED', [selectedAvailableFields.filter(a => a.group === group.id).length]) }})</span></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-if="!group.items.length"
            >
              <v-list-item-content>
                <v-list-item-subtitle>{{ $t('SETTINGS_CONTACTS_ALL_SELECTED_HINT') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="item in group.items"
              :key="item.id"
              @click="onAvailableToggle(item, group.items)"
              ripple
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn v-if="isAvailableSelected(item)" icon @click.stop="onMoveRight()" color="primary"><v-icon>mdi-chevron-right</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-flex>
      <v-flex sm12 md6>
        <v-list class="fields">
          <span v-if="debug">{{ brokenFields }}</span>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('RESULTS_SELECT_COLUMNS_VISIBLE') }} ({{ visibleFields.length }}) <span v-if="selectedVisibleFields.length" class="body-1">({{ $t('SETTINGS_CONTACTS_NUM_SELECTED', [selectedVisibleFields.length]) }})</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="!visibleFields.length"
          >
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('SETTINGS_CONTACTS_NO_SELECTED_HINT') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <draggable v-model="visibleFields" group="visibleFields">
            <v-list-item
              v-for="(item, idx) in visibleFields"
              :key="idx"
              @click="onVisibleToggle(item)"
              ripple
            >
              <v-list-item-action>
                <v-btn v-if="isVisibleSelected(item)" icon @click.stop="onMoveLeft()" color="primary"><v-icon>mdi-chevron-left</v-icon></v-btn>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </draggable>
        </v-list>
      </v-flex>
      <v-flex sm12>
        <v-slider
          class="margin-slider"
          v-model="rowsIndex"
          :label="$t('RESULTS_PER_PAGE')"
          :tick-labels="rowsPerPage"
          thumb-label="always"
          :value="0"
          min="0"
          max="4"
          ticks="always"
          tick-size="4"
        >
          <template v-slot:thumb-label="props">
              {{ rowsPerPage[props.value] }}
          </template>
        </v-slider>
      </v-flex>
      <v-flex sm12>
        <v-checkbox
          v-model="auto_refresh_results"
          :label="$t('RESULTS_REFRESH_CHECKBOX')"
        ></v-checkbox>
      </v-flex>
      <v-flex sm12>
        <v-btn @click="onResetContacts()" title="Reset to default settings">{{ $t('RESULTS_SELECT_DEFAULT') }}</v-btn>
        <v-btn color="primary" @click="onSave()">{{ $t('SETTINGS_SAVE') }}</v-btn>
      </v-flex>
        </v-layout>
        </v-card-text>
      </v-card>
    </v-sheet>
    <v-snackbar v-model="snackbar" color="success" :timeout="1000">Saved</v-snackbar>
  </v-layout>
</template>

<script>
import convert from 'xml-js'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import Settings from '../services/Settings'

export default {
  name: 'Settings',
  components: {
    draggable,
  },
  data() {
    return {
      debug: false,

      groups: {},
      fields: [],
      selectedAvailableFields: [],
      visibleFields: [],
      selectedVisibleFields: [],
      brokenFields: [],
      results_per_page: 100,
      auto_refresh_results: true,

      snackbar: false,
      rowsPerPage: [10, 20, 30, 50, 100],
      rowsIndex: 0,

      shiftKeyOn: false,
      lastSelected: null,

    }
  },
  computed: {
    ...mapGetters(['isDebug', 'data', 'settings']),
    availableFields() {
      return this.fields.map(a => ({ ...a, items: a.items.filter(b => !this.visibleFields.map(c => c.value).includes(b.value)) }))
    },
  },




  created() {
    const self = this;
    self.keyDownHandler = function ({ key }) {
      if (key == "Shift") self.shiftKeyOn = true;
      console.log('shiftKeyOn:', self.shiftKeyOn)
    };
    self.keyUpHandler = function ({ key }) {
      if (key == "Shift") self.shiftKeyOn = false;
      console.log('shiftKeyOn:', self.shiftKeyOn)
    };
    window.addEventListener("keydown", this.keyDownHandler);
    window.addEventListener("keyup", this.keyUpHandler);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keyDownHandler);
    window.removeEventListener("keyup", this.keyUpHandler);
  },



  mounted() {
    let fields = [], group

    group = {
      id: 'g1',
      icon: 'mdi-account-card-details',
      header: this.$t('CONTACT_MAIN_DATA'),
      items: this.data.fields.filter(a => a.field).map(a => ({ ...a, value: `i${a.value}`, label: this.$t(a.text), group: 'g1' })),
      // open: true,
    }
    fields.push(group)
    this.$set(this.groups, 'g1', true) // is open
    // this.$set(this.groups, 'g1', false) // is closed

    group = {
      id: 'g3',
      icon: 'mdi-account-settings',
      header: this.$t('CONTACT_FREE_FIELDS'),
      items: this.data.custom_fields.filter(a => a.field).map(a => ({ ...a, value: `f${a.value}`, group: 'g3' })),
    }
    group.items.sort((a, b) => ('' + a.label).localeCompare(b.label))
    fields.push(group)
    this.$set(this.groups, 'g3', false) // is closed

    this.fields = fields

    let visibleFields = this.fields.map(a => a.items).flat().filter(a => this.settings.user.visible_columns.column.includes(a.field))
    // sort visibleFields by this.settings.user.visible_columns.column order
    this.brokenFields = this.settings.user.visible_columns.column.map(a => a !== undefined && visibleFields.find(b => b.field === a) ? 1 : a).filter(a => a !== 1)
    this.visibleFields = this.settings.user.visible_columns.column.map(a => visibleFields.find(b => b.field === a)).filter(Boolean)
    this.results_per_page = this.settings.user.results_per_page
    this.rowsIndex = this.rowsPerPage.indexOf(parseInt(this.results_per_page))
    this.auto_refresh_results = !!+this.settings.user.auto_refresh_results
  },

  watch: {
    rowsIndex(val) {
      this.results_per_page = this.rowsPerPage[val]
    }
  },

  methods: {
    season (val) {
      return this.icons[val]
    },
    isAvailableSelected(field) {
      return this.selectedAvailableFields.map(a => a.value).indexOf(field.value) >= 0
    },
    onAvailableToggle(field, groupItems) {
      if (this.shiftKeyOn && this.lastSelected) {
        let start = groupItems.findIndex((f) => f == this.lastSelected);
        let end = groupItems.findIndex((f) => f == field);
        if (start - end > 0) {
          let temp = start;
          start = end;
          end = temp;
        }
        for (let i = start; i <= end; i++) {
          if (!this.selectedAvailableFields.filter(a => a.value == groupItems[i].value).length) {
            this.selectedAvailableFields.push(groupItems[i]);
          }
        }
      } else {
        let idx = this.selectedAvailableFields.map(a => a.value).indexOf(field.value)
        if (idx >= 0) {
          this.selectedAvailableFields.splice(idx, 1)
        } else {
          this.selectedAvailableFields.push(field)
        }
      }
      this.lastSelected = field
    },
    isVisibleSelected(field) {
      return this.selectedVisibleFields.map(a => a.value).indexOf(field.value) >= 0
    },
    onVisibleToggle(field) {
      let idx = this.selectedVisibleFields.map(a => a.value).indexOf(field.value)
      if (idx >= 0) {
        this.selectedVisibleFields.splice(idx, 1)
      } else {
        this.selectedVisibleFields.push(field)
      }
    },
    onMoveRight() {
      this.visibleFields = this.visibleFields.concat(this.selectedAvailableFields)
      this.selectedVisibleFields = this.selectedAvailableFields
      this.selectedAvailableFields = []
    },
    onMoveLeft() {
      this.visibleFields = this.visibleFields.filter(a => !this.selectedVisibleFields.includes(a));
      this.selectedAvailableFields = this.selectedVisibleFields
      this.selectedVisibleFields = []
    },
    onResetContacts() {
      const defaults = ['lastname', 'firstname', 'company', 'email', 'newsletter', 'bounced', 'phone', 'zipStreet', 'city']
      this.visibleFields = this.fields.find(a => a.id === 'g1').items.filter(a => defaults.includes(a.id))
      this.results_per_page = 100
      this.auto_refresh_results = true
    },
    onSave() {
      const jsonObject = {
        request: {
          setting: {
            _attributes: {
              name: 'user',
            },
            auto_refresh_results: +this.auto_refresh_results,
            results_per_page: this.results_per_page,
            visible_columns: {
              column: []
            }
          }
        }
      }
      this.visibleFields.forEach(a => {
        let column = a.field
        jsonObject.request.setting.visible_columns.column.push({ _text: column })
      })
      const xml = convert.json2xml(jsonObject, {compact: true})
      const self = this
      new Settings(this.$api).save(xml)
      .then(() => {
        self.settings.user.visible_columns.column = self.visibleFields.map(a => a.field)
        self.settings.user.results_per_page = self.results_per_page
        self.settings.user.auto_refresh_results = +self.auto_refresh_results
        self.$store.commit('setSettings', self.settings)
        self.snackbar = true
        self.$store.commit('setSearchesSortBy', [])
        self.$router.go(-1)
      })
    },
  },
}
</script>

<style>
  .margin-slider {
    margin-top: 50px;
  }
</style>
